import Vue from 'vue'
import title from './fragments/title'
import { mailto, whatsApp } from '@/util/catalog'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const host = (data) => {
  const host = data?.host

  if (!host) return ''

  return `
    <details>
      ${title(translate(area + 'host'))}
      <content>
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'name')}
        </h6>
        <p class="body-2 mb-3">
          ${host.name}
        </p>

        <div class="row no-gutters">
          <div class="col mw-150">
            <h6 class="text-uppercase grey--text">
              ${translate(area + 'phone')}
            </h6>
            <p class="body-2 mb-3">
              ${whatsApp(host.phone)}
            </p>
          </div>
          <div class="col">
            <h6 class="text-uppercase grey--text">
              ${translate(area + 'user')}
            </h6>
            <p class="body-2 mb-3">
              ${mailto(host.username)}
            </p>
          </div>
        </div>
      </content>
    </details>
  `
}

export default host
